import React from 'react'
import styled, { useTheme } from 'styled-components'
import { Icon } from '../icon'

export interface VisitedProps {
  avatars: string[]
  count: number
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
`
const Avatar = styled.img`
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 50%;
`
const Ellipsis = styled((props: { className?: string}) => {
  const { colors } = useTheme()
  return (
    <div className={props.className}>
      <Icon code="gengduo-a" size={16} color={colors.textLight} />
    </div>
  )
})`
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.fail};

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`
const Text = styled.span`
  color: ${props => props.theme.colors.textLight};
  font-size: 0.75rem;
  opacity: 0.6;
  &:not(:first-child) {
    margin-left: 0.5rem;
  }
`
export const Visited: React.VFC<VisitedProps> = ({ avatars, count }) => {
  return (
    <Container>
      {avatars.map(src => <Avatar key={src} src={src}/>)}
      {count > avatars.length && <Ellipsis />}
      <Text>{count} 人访问过</Text>
    </Container>
  )
}
